module.exports = __webpack_public_path__ + "static/img/xunli.8986fa62.jpg";